import type { Partner } from '@/data'
import api from '..'

export interface PartnerPayload {
  name: string
  affiliate_id: number
}

export async function createPartner(payload: PartnerPayload): Promise<Partner> {
  const res = await api.post('/partners', payload)
  return res.data.data
}
